import React, { Component } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter,  Form, 
    FormGroup, UncontrolledTooltip, Card, CardBody, CardHeader} from "reactstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { getAdminUsers, deleteUser, updateUser, resetPasswordFunc } from "../../actions/actionAdminUser";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { withRouter } from "react-router-dom";
import "react-table/react-table.css";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { renderCheckbox, renderField, required, password } from "../../utils/formValidations.js";
import { NotificationManager } from "react-notifications";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import { fuzzySearch } from "../../utils/helpers";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Users",path:"/adminUser",isActive: true}
];

const validate = values => {
    const errors = {};
    if (values.newPassword !== values.confirmPassword) {
        errors.confirmPassword = "Passwords Do Not Match";
    }
    return errors;
};

class AdminUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            modalreset: false,
            pages: 1,
            userId: null,
            userName: null,
            password: "",
            confirmPassword: "",
            checked: false
        };
        this.resetConfirm = this.resetConfirm.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.toggle1 = this.toggle1.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    resetConfirm(userId,userName){
        this.setState({modalreset: !this.state.modalreset,
            userId: userId,
            userName: userName
        });
    }

    resetPassword(userData){
        let currentUser = this.props.users.find(user => user.user_id === this.state.userId);
        currentUser.password = userData.newPassword;
        this.props.resetPasswordFunc(currentUser).
            then(() => this.handlePasswordResetSuccess()).
            catch(() => this.handlePasswordResetFailure());
    }

    handlePasswordResetSuccess(){
        const {errorResetPasswordMessage} = this.props;
        if(errorResetPasswordMessage) {
            NotificationManager.error(errorResetPasswordMessage,"Reset Password", 3000);
        }
        else {
            this.props.initialize({ password: "" });
            this.setState({modalreset: false});
            NotificationManager.success("Successfully Reset Password","Reset Password",3000);
        }
    }

    handlePasswordResetFailure(){
        const {resetPasswordError} = this.props;
        if(resetPasswordError){
            NotificationManager.error(resetPasswordError,"Reset Password", 3000);
        }
        else {
            NotificationManager.error("Failed to Reset Password","Reset Password", 3000);
        }
    }

    deleteConfirm(userId,userName){
        this.setState({modal: !this.state.modal,
            userId: userId,
            userName: userName});
    }

    deleteUser(){
        this.props.deleteUser(this.state.userId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteUserErrorMessage} = this.props;
        if(deleteUserErrorMessage) {
            NotificationManager.error(deleteUserErrorMessage,"Delete User", 3000);
        }
        else{
            this.setState({modal: false});
            this.props.getAdminUsers();
            NotificationManager.success("Successfully Deleted User","Delete User", 3000);
        }
    }

    handleDeleteError(){
        const {deleteUsersError} = this.props;
        if(deleteUsersError){
            NotificationManager.error(deleteUsersError,"Delete User", 3000);
        }
        else{
            NotificationManager.error("Failed to Delete User","Delete User", 3000);
        }
    }

    toggle1(){
        this.setState({modalreset: !this.state.modalreset});
        this.props.initialize({  newPassword: "" , confirmPassword: "" });
    }

    toggle(){
        this.setState({modal: !this.state.modal});
    }

    componentDidMount(){
        this.props.getAdminUsers();
    }

    render() {
        if (this.props.getUsersLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const { users, handleSubmit} = this.props;
        const { loading } = this.state;
        const checked = this.state.checked;
        const columns = [{
            Header: "User Name",
            accessor: "username",
            filterMethod: fuzzySearch

        },
        {
            Header: "Locked",
            accessor: "locked",
            filterMethod: fuzzySearch,
            Cell: (data) => (<div> {data.original.locked ? 'True' : 'False'}</div>)
        },
        {
            Header: "Disabled",
            accessor: "disabled",
            filterMethod: fuzzySearch,
            Cell: (data) => (<div> {data.original.disabled ? 'True' : 'False'}</div>)
        },
        {
            Header: "First Name",
            accessor: "first_name",
            filterMethod: fuzzySearch
        },
        {
            Header: "Last Name",
            accessor: "last_name",
            filterMethod: fuzzySearch
        },
        {
            Header: "Last Session",
            accessor: "last_session",
            filterable: false,
            Cell: (data) => (<div>{moment(data.value).format("L h:mm A")} </div>),
        },
        {
            Header: "Actions",
            filterable: false,
            sortable: false,
            Cell: (data) => (<div className="action-btn">
                <Link className="btn btn-success" id={"TooltipComponent"} to={{ pathname: `/viewuser/${data.original.user_id}` }}>
                    <i className="fa fa-eye"></i> </Link>
                <Link className="btn btn-warning" id={"Tooltipss"} to={{ pathname: `/updateuser/${data.original.user_id}` }}>
                    <i className="fa fa-pencil"></i> </Link>                                                                                      
                <button className="btn btn-info" hef="#" id={"Tooltipps"} onClick={() => this.resetConfirm(data.original.user_id,data.original.username)}>
                    <i className="fa fa-key"></i> </button> 
                <button className="btn btn-danger" href="#" id={"Tooltips"} onClick={() => this.deleteConfirm(data.original.user_id,data.original.username)}>
                    <i className="fa fa-trash-o"></i> </button>
                <UncontrolledTooltip placement="right" target={"TooltipComponent"}> View </UncontrolledTooltip>
                <UncontrolledTooltip placement="right" target={"Tooltipss"}> Edit </UncontrolledTooltip>
                <UncontrolledTooltip placement="right" target={"Tooltipps"}> Reset Password </UncontrolledTooltip>
                <UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
            </div> ),
        },
        ];
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Users</strong>
                                <Link className="pull-right" to={{ pathname: "/createuser" }}>
                                    <Button className="pull-right" size="sm" color="dark">
                                        Create New User    
                                    </Button>
                                </Link> 
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    filterable
                                    data={users}
                                    loading={loading}
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table"
                                    defaultSorted={[{id: "username"}]}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modalreset} toggle={this.toggle1} className={this.props.className}>
                    <Form onSubmit={handleSubmit(this.resetPassword)}>
                        <ModalHeader toggle={this.toggle1}> Reset Password <i className="fa fa-key" aria-hidden="true"></i>
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Row>
                                    <Col sm="5">
                                        <label className="requiredasterisk">New Password: </label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field 
                                            id="newPassword"
                                            type="password"
                                            name="newPassword"
                                            component={renderField} 
                                            validate={[required, password]}
                                        /> 
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm="5">
                                        <label className="requiredasterisk">Confirm Password </label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field
                                            id="confirmPassword"
                                            type="password"
                                            name="confirmPassword"
                                            component={renderField}
                                            validate={[required, password]}
                                        />                                            
                                    </Col>
                                </Row>
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button type="submit" size="sm" color="primary"> <i className="fa fa-dot-circle-o"></i> Submit</Button>
                            <Button onClick={this.toggle1} size="sm" color="basic"><i className="fa fa-ban"></i> Cancel</Button>
                        </ModalFooter>
                    </Form>  
                </Modal>

                <Modal isOpen={this.state.modal} toggle={this.deleteConfirm} className={this.props.className}>
                    <ModalHeader toggle={this.deleteConfirm}>Delete User <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                      Confirm Delete User{this.state.userName ? <span> - {this.state.userName}?</span> : "?"}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.deleteUser} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        <Button onClick={this.toggle} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}


AdminUser.propTypes = {
    updateUser: Proptypes.func.isRequired,
    history: Proptypes.object.isRequired,
    updateUsersError: Proptypes.func,
    updatErrorWarning: Proptypes.func,
    resetPasswordError: Proptypes.func,
    deleteUser: Proptypes.func.isRequired,
    resetPasswordFunc: Proptypes.func,
    errorResetPasswordMessage: Proptypes.string,
    deleteUsersError: Proptypes.func,
    deleteUserErrorMessage: Proptypes.func,
    getAdminUsers: Proptypes.func.isRequired,
    initialize: Proptypes.func,
    getUsersLoading: Proptypes.bool,
    users: Proptypes.array,
    handleSubmit:  Proptypes.func,
    className: Proptypes.object 
};

let  AdminUserFormWithRouter = withRouter(AdminUser);

let AdminUserForm = connect(state => 
    ({
        users: state.admin.users || [],
        errorResetPasswordMessage: state.admin.errorResetPasswordMessage || null,
        updatErrorWarning: state.admin.updatErrorWarning || null,
        resetPasswordError: state.admin.resetPasswordError || null,
        deleteUsersError: state.admin.deleteUsersError || null,
        getUsersLoading: state.admin.getUsersLoading || false,
        deleteUserErrorMessage: state.admin.deleteUserErrorMessage || null
    }),
dispatch => 
    ({  
        getAdminUsers: () => dispatch(getAdminUsers()),
        resetPasswordFunc: (data) => dispatch(resetPasswordFunc(data)),
        updateUser: (data) => dispatch(updateUser(data)),
        deleteUser: (data) => dispatch(deleteUser(data))
    }))(AdminUserFormWithRouter);


export default reduxForm({
    form: "adminuserForm",
    validate
})(AdminUserForm);



// WEBPACK FOOTER //
// ./src/views/AdminUser/AdminUser.js